/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：673
 */

module.exports = JSON.parse("{\"webviewRefusedUrl\":[\"https://baidu.com\",\"https://www.baidu.com\",\"https://google.com\",\"https://www.google.com\",\"https://qq.com\",\"https://www.qq.com\",\"https://v.qq.com\",\"https://www.v.qq.com\",\"https://mi.com\",\"https://www.mi.com\",\"https://jd.com\",\"https://www.jd.com\",\"https://zhihu.com\",\"https://www.zhihu.com\"]}")
